export default __webpack_public_path__ + "static/branding-image-b1cf2710e665d20da87ff0152d79d011.png";